export const barcodeByInventoryItemByActiveByValue = /* GraphQL */ `
  query BarcodeByInventoryItemByActiveByValue(
    $inventoryItemId: ID
    $activeValue: ModelBarcodeBarcodeByInventoryItemByActiveByValueCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelBarcodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    barcodeByInventoryItemByActiveByValue(
      inventoryItemId: $inventoryItemId
      activeValue: $activeValue
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        active
        status
        value
        isScanned
        scannedOut
        reloadYardId
        inventoryId
        locationId
        inventoryItemId
      }
      nextToken
    }
  }
`;